import request from '@/utils/request.js'

export default {
    //查询书籍详情
    fetch(params){
        return request({
            url: '/api/book/fetch',
            method: 'GET',
            params
        })
    },
    //查询书籍列表
    list(params){ 
        return request({
            url: '/api/book/list',
            method: 'GET',
            params
        })
    }
}